import React from "react";
import { Sparkles, CheckCircle2 } from "lucide-react";

const AIOverviewCapsule = ({ title = "Executive AI Answer Capsule", content, bullets = [] }) => {
  return (
    <div data-speakable="true" className="speakable-summary my-10 p-6 md:p-8 rounded-3xl bg-indigo-50/90 dark:bg-gradient-to-r dark:from-indigo-950/40 dark:via-slate-900/60 dark:to-purple-950/40 border border-indigo-200/80 dark:border-indigo-500/30 backdrop-blur-xl shadow-lg shadow-indigo-100/50 dark:shadow-2xl relative overflow-hidden space-y-4">
      {/* Background Accent Glow */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />

      {/* Header Badge */}
      <div className="flex items-center justify-between border-b border-indigo-200/80 dark:border-indigo-500/20 pb-4">
        <div className="flex items-center gap-2 text-indigo-700 dark:text-indigo-400 font-bold text-sm tracking-wide uppercase">
          <Sparkles size={18} className="animate-pulse text-indigo-600 dark:text-indigo-400" />
          <span>{title}</span>
        </div>
      </div>

      {/* Factual Passage Body */}
      <p className="text-slate-800 dark:text-slate-200 text-base leading-relaxed font-normal">
        {content}
      </p>

      {/* Factual Highlights Grid */}
      {bullets.length > 0 && (
        <div className="grid sm:grid-cols-2 gap-3 pt-2">
          {bullets.map((bullet, idx) => (
            <div key={idx} className="flex items-start gap-2 text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-white/5 p-3 rounded-xl border border-indigo-100 dark:border-white/5 shadow-sm dark:shadow-none font-medium">
              <CheckCircle2 size={16} className="text-emerald-600 dark:text-emerald-400 flex-shrink-0 mt-0.5" />
              <span>{bullet}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AIOverviewCapsule;
